import React, { cloneElement } from 'react';
import Page from '../components/Page';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
} from 'reactstrap';
import axios from 'axios';
import StorageService from '../services/StorageService';
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md';
import { BsPlusSquareFill } from 'react-icons/bs';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import classnames from 'classnames';
import PosTaxForm from '../components/PosTaxForm';
import { getProfile } from '../utils/dropdownlist';
import { IconContext } from 'react-icons/lib';

class PosTaxTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      confirmModal: false,
      isGlobal: '',
      isEdit: false,
      taxList: [],
      redirect: false,
      selectedId: '',
      store_id: '',
      tax_code: '',
      name: '',
      company_id: '',
      rate: '',
      reg_no: '',
      inclusive: '',
      options: '',
    };
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');

    //if (user.superUser) {
    this.getTaxList();
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getTaxList();
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  delete = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    let data, fullUrl;
    if (this.state.isGlobal) {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        taxtype_id: this.state.selectedId,
        delete_by: user.email,
      };
      fullUrl = url + ':3001/v1/tax/delete';
    } else {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        tax_id: this.state.selectedId,
        store_id: this.props.data.store_id,
        remove_by: user.email,
      };
      fullUrl = url + ':3001/v1/store/tax/delete';
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          });
          return;
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Tax ${
            this.state.isGlobal ? 'deleted' : 'removed'
          } successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        this.setState({ confirmModal: false });
        this.getTaxList();
      })
      .catch(error => {
        alert(error);
      });
  };

  getTaxList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    let fullUrl,
      store_id = '';
    if (!this.props.isGlobal) {
      store_id = this.props.data.store_id;
      data.store_id = store_id;
      fullUrl = url + ':3001/v1/store/tax';
    } else {
      fullUrl = url + ':3001/v1/tax';
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            taxList: result.data,
            store_id: store_id,
            isGlobal: this.props.isGlobal,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <div className="text-right mb-3">
          <div className="ps-btn-group">
            {/* <Button
              className="theme-button theme-button-primary"
              onClick={this.toggle('ADD', null)}
            >
              {this.state.isGlobal ? 'Create' : 'Add'}
            </Button> */}
            <Button color="link" onClick={this.toggle('ADD', null)}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <BsPlusSquareFill size={25} />
              </IconContext.Provider>
            </Button>
          </div>
        </div>
        <Table responsive hover className="ps-table tb-col-6">
          <thead>
            <tr>
              <th>Tax Code</th>
              <th>Name</th>
              <th>Rate(%)</th>
              <th>Reg No.</th>
              <th>Inclusive</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.taxList.length < 1 && (
              <tr>
                <td colSpan="6">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new tax
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.taxList.length > 0 &&
              this.state.taxList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.tax_code}</td>
                    <td>{item.name}</td>
                    <td>{item.rate}</td>
                    <td>{item.reg_no}</td>
                    <td>
                      <span
                        className={
                          'ps-indicator ' +
                          (item.inclusive == '1' ? 'on' : 'off')
                        }
                      >
                        {item.inclusive == '1' ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td>
                      <div className="ps-action-button">
                        {this.state.isGlobal && (
                          <Button
                            className="theme-button theme-button-secondary"
                            onClick={this.toggle('Edit', item.id)}
                          >
                            Edit
                          </Button>
                        )}
                        <Button
                          color="link"
                          className="theme-button theme-button-primary-light"
                          onClick={this.toggleConfirmModal(item.name, item.id)}
                        >
                          {this.state.isGlobal ? 'Delete' : 'Remove'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <PosTaxForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            Delete Tax
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              No
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
export default PosTaxTable;
